import List from "@elements/List/List";
import { ListItem } from "@elements/List/ListItem/ListItem";
import cx from "classnames";
import { useState } from "react";
import { Link } from "react-router-dom";

import { HeaderMenuDetails } from "./HeaderMenuConstants";
import { HeaderMenuType } from "./HeaderMenuTypes";
import { SubMenuDropdown } from "./HeaderSubMenuDropdown";

type HeaderMenuListProps = {
  testId: string;
  items: HeaderMenuDetails[];
  type: HeaderMenuType;
  isHamburger: boolean;
};

export function HeaderMenuList({
  testId,
  items,
  type,
  isHamburger,
}: HeaderMenuListProps) {
  const [dropdown, setDropdown] = useState(isHamburger);

  const toggleDropdown = () => {
    setDropdown((prev) => !prev);
  };

  return (
    <List
      testId={`${testId}-${type}-list`}
      className={cx(
        "block",
        type === "social" && "xs:inline-flex xs:pt-sm lg:pt-0",
        type === "main" &&
          "lg:inline-flex lg:w-full lg:justify-center lg:mb-6 lg:relative",
      )}
    >
      {items.map((item: HeaderMenuDetails, index: number) => (
        <ListItem
          key={`${testId}-item-${index}`}
          testId={`${testId}-item-${index}`}
          className={cx(
            "font-sans text-gray-200",
            type === "social" && "px-4 mx-0.5 lg:px-2 lg:mx-0 lg:py-1",
            type === "main" && item.url && "pt-sm lg:pt-0 lg:flex",
            type === "top-mobile" && "pt-sm first:pt-md even:pt-xs lg:pt-0",
          )}
        >
          {item.child && item.childrens ? (
            <>
              {!isHamburger ? (
                <button
                  type="button"
                  aria-haspopup="menu"
                  aria-expanded={dropdown ? "true" : "false"}
                  className="font-bold text-md lg:text-sm lg:px-3 lg:py-2 hover:text-pink-200"
                >
                  <div
                    role="presentation"
                    onClick={() => {
                      toggleDropdown();
                    }}
                    onKeyDown={() => {
                      toggleDropdown();
                    }}
                    className="flex"
                  >
                    {item.title}
                    {dropdown ? (
                      <span className="ml-1 hover:after:border-y-pink-200 after:inline-block after:content-[''] after:border-solid after:border-x-[.3em] after:border-x-transparent after:border-b-[.3em] after:border-t-0 after:align-[.15em]" />
                    ) : (
                      <span className="ml-1 hover:after:border-y-pink-200 after:inline-block after:content-[''] after:border-solid after:border-x-[.3em] after:border-x-transparent after:border-t-[.3em] after:border-b-0 after:align-[.15em]" />
                    )}
                  </div>
                </button>
              ) : null}

              <SubMenuDropdown
                submenus={item.childrens}
                dropdown={dropdown}
                testId={testId}
                type={type}
              />
            </>
          ) : (
            <>
              <Link
                reloadDocument
                key={index}
                to={item.url}
                target={item.newTab ? "_blank" : "_self"}
                rel="noreferrer"
                className={cx(
                  "font-bold text-md tracking-[0.5px]",
                  item.images && item.title && "inline-flex",
                  type === "top-mobile" && "text-red-100",
                  type === "main" &&
                    "hover:text-pink-200 lg:text-sm lg:px-2.5 lg:py-2",
                )}
              >
                {item.images ? (
                  <img
                    src={item.images}
                    alt={`${item.alt}-icon`}
                    className={cx(
                      "h-5",
                      type === "social" && "xs:h-6 lg:h-5",
                      item.url === "/tabla" &&
                        "xs:h-8.5 xs:w-18 xs:mt-xs xs:ml-3xs xs:mb-3xs",
                      type === "top-mobile" && "h-xm pr-1 mt-0.5 ml-1",
                      type === "main" && "lg:h-4.5 lg:w-12.5 lg:mt-1",
                    )}
                  />
                ) : null}
                {item.title}
              </Link>
            </>
          )}
        </ListItem>
      ))}
    </List>
  );
}
